import React from 'react';
import PropTypes from 'prop-types';

import Menu from './components/Menu';
import useStyles from './useStyles';

const AppLayout = props => {
  const { children } = props;
  const classes = useStyles();

  return (
    <div className={classes.paper}>
      <Menu />
      <main className={classes.content}>{children}</main>
    </div>
  );
};

AppLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppLayout;



// WEBPACK FOOTER //
// ./src/layouts/NonAuthLayout/NonAuthLayout.js